import React from 'react'
import '../container.css'
import resim1 from './images2/1.jpeg'
import resim3 from './images2/3.JPG'
import resim4 from './images2/4.jpeg'
import resim5 from './images2/5.jpeg'


const Hebaryum = () => {
    return (
        <div className="info-pages-container">
            <h2 id="head">ODTÜ Bitkileri Herbaryumu:</h2>
            <br></br>
            <p>ODTÜ Bitkileri Herbaryumu, yerleşkede bulunan bitki türlerinin toplanıp, kurutulup,
kartonlara yapıştırılıp, kataloglandığı bir bitki arşividir.</p>
            <br></br>
            <h3>Herbaryum Nedir ve Ne işe Yarar?</h3>
            <br></br>
            <p>Herbaryum, bitkilerin tanımlanmasında kullanılmak üzere kurutulmuş bitki örneklerinin
kataloglanıp saklandığı arşiv, koleksiyondur. Bu koleksiyonlar biyoloji, tıp, eczacılık,
ormancılık, tarım gibi alanlardaki çalışmalarda referans kaynağı olarak kullanılır.
Tanımlanacak bitki örnekleri, herbaryumdaki örneklerle karşılaştırılır, belli özellikleri (ör.
yaprak şekli, çiçek boyutları, tüy şekli vb.) referans alınarak teşhis edilir.
Herbaryumlarda bulunan bitki örneklerinin iyi bir şekilde kurutulması ve hazırlanması ilk
kuraldır. Daha sonraki en önemli aşama, bitkinin doğru bir şekilde tanımlanmasıdır.
Bundan sonra da bitki ile ilgili bilgilerin doğru bir şekilde veri tabanına girilmesi ve
bitkinin yapıştırıldığı kartonlara etiket hazırlanıp yapıştırılması gerekir.</p>
            <br></br>

            
            <div>
            <img src={resim1}></img>
            </div>
            
            <h3>Herbaryum ne amaçla kullanılır?</h3>
            <br></br>
            <p>Bitkilerin tanımlanmasında o ülke veya o bölge için hazırlanmış flora kitaplarında
bulunan tanımlama anahtarlarından faydalanılır. Bu anahtarlar, belli özelliklerine göre
bitkileri birbirinden ayırt etmeye yarar. Ancak bu anahtarlara rağmen çoğu zaman bitkiyi
doğru bir şekilde tanımlayabilmek için benzer örneklere bakıp karşılaştırmak gerekir.
İşte bunun için herbaryumlarda bulunan kurutulmuş bitki örneklerine ihtiyaç duyulur.
Elinizdeki örnekleri herbaryumdakilerle karşılaştırarak doğru bir şekilde tanımlamaya
çalışırsınız. Eğer hem anahtar hem de örnekler arasında örneğinizi tanımlayamazsanız
yeni bir tür bulmuş olduğunuzu anlarsınız.
</p>
            <br></br>
            <div>
            <img src={resim3}></img>
            </div>

            <br></br>
            <h3>Herbaryum için Bitki Örneği Nasıl Hazırlanır? </h3>
            <br></br>
            <p>İlk aşama doğadan örnek toplanmasıdır. Burada birinci kural mümkün olduğunca az
canlıya zarar vermeye özen göstermek ve toplanan türün alandaki popülasyonunu
tehlikeye sokmayacak kadar örnek toplamaktır. Daha sonra dikkat edilmesi gereken
nokta toplanan örneğin, bitkinin bütün ana organlarını içermesidir: Kök, gövde, dal,
yaprak, çiçek, meyve ve tohum gibi. Bu toplama sırasında bitkinin bulunduğu yerin
özellikleri de not edilir: Koordinat, yükseklik, yaşam ortamı, ana kaya bilgileri gibi. Bu
bilgiler de alındıktan sonra, toplanan örneğin düzgün bir şekilde kurutulabilmesi için
preslenmesi gerekir. Bu noktada, tohum, meyve gibi bitki bölümleri ayrı bir kutu veya
poşette de saklanabilir. Presleme işlemi için 45 x 30 cm boyutlarında tahtadan veya
metalden yapılmış değişik tiplerde presler, presleri sıkmak için kayışlar ve kurutmak için
de gazete kâğıtları (44x28 cm boyutlarında), oluklu mukavva, filtreli kâğıt gerekir.
Kurutulan bitkiler tanımlandıktan sonra yukarıda belirtilen bilgilerle beraber bitkinin adı
bir etikete yazılır ve bitki örneği ile birlikte etiket de bir kartona yapıştırılır. Bilgiler
herbaryum veri tabanına da aktarılmalıdır. Bundan sonra bitki örneği araştırmacıların
daha sonra kullanabilmesi için o türle ilgili dolaba kaldırılır.</p>
            <br></br>

            <div>
            <img src={resim4}></img>
            </div>
            
            <br></br>

            <div>
            <img src={resim5}></img>
            </div>

            <h3>Daha fazla bilgi için:</h3>
            <a href="http://biology.science.ankara.edu.tr/herbaryumank/">Ankara Üniversitesi Fen Fakültesi Hebaryumu (ANK) "Hebarium Turcicum”</a>
            <a href="http://www.duof.duzce.edu.tr/Sayfa/2616/herbaryumun-yapmanin-amaci">Düzce Üniversitesi Orman Fakültesi Herbaryumu</a>
            <a href="http://www.herb.gazi.edu.tr/index.php">Gazi Üniversitesi Herbaryumu</a>
            <a href="http://www.ktu.edu.tr/ormanbotanigi-herbaryumteknikleri">Karadeniz Teknik Üniversitesi Orman Mühendisliği Bölümü Orman Botaniği Ana Bilim Dalı </a>
            <a href="http://ngbb.org.tr/herbaryum2.html">Nezahat Gökyiğit Botanik Bahçesi</a>
            <a href="https://tr.wikipedia.org/wiki/Herbaryum">Vikipedi</a>
            <div style={{marginTop: 15}}>
                <a href="#head"><i class="fas fa-arrow-up" style={{fontSize:30}}></i></a>
            </div>
        </div>
    )
}

export default Hebaryum